import React, {Component, Fragment} from "react";
import {formatDate} from "../../../shared/services/utils/utils";

class FtoComments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notes: [],
    }
  }

  componentDidMount() {

  }

  render() {
    return (
      <div>
       <div style={{ padding: '20px'}}>
         <button
           data-tip="Add comment"
           className="button small primary"
           onClick={() => this.props.onAddNotes()}
         >
           <span>Add comment </span>
           <i className="fa fa-plus"/>
         </button>
       </div>

        <div>{
          this.props.comments.map(n => <div style={{padding: '0 20px 20px 20px'}} key={n.id}>
            {n.user && this.props.userContext.userGuid === n.user.userGuid && <div>
              {/*<button*/}
              {/*  data-tip="Edit note below"*/}
              {/*  className="button small secondary"*/}
              {/*  onClick={() => this.props.onEditNote(n)}*/}
              {/*>*/}
              {/*  <i className="fa fa-pencil"/>*/}
              {/*</button>*/}

              <button
                data-tip="Delete comment bellow"
                className="button small danger"
                onClick={() => this.props.deleteNote(n)}
              >
                <i className="fa fa-trash"/>
              </button>
            </div>}
            <div><b>Date: </b>{formatDate(n.inserted_at)}</div>
            {n.user && <div><b>Author: </b>{n.user.lastName} {n.user.firstName}</div>}
            <div><b>Category: </b>{n.category}</div>
            <div><b>Comments: </b></div>
            <div style={{
              whiteSpace: "pre-line",
              unicodeBidi: "embed"
            }}>{n.comment}</div>
          </div>)
        }</div>
      </div>

    )
  }
}

export default FtoComments
